import React, { Suspense, useEffect, useState } from "react";
import "./App.scss";
import Footer from "./containers/Footer";
import { ToastContainer } from "react-toastify";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import ProtectedRoutes from "./routing/ProtectedRoutes";
import PublicRoutes from "./routing/PublicRoutes";
import { useDispatch, useSelector } from "react-redux";
import { getAppDetails } from "./redux/app/actions";
import PublicSportsBook from "./views/pages/privatePages/sportsBook";
import BeforeLoginFooter from "./containers/BeforeLoginFooter";
import TestSportsBook from "./views/pages/privatePages/sportsBook/testSportsBook";
import DepositGateway from "./views/pages/privatePages/deposit/depositGateway";
import GatewaysList from "./views/pages/privatePages/deposit/gatewaysList";
import Slots from "./views/pages/privatePages/Slots";
import Spribe from "./views/pages/privatePages/Spribe";
import Loader from "./assets/images/loader.webp";
import ScrollToTop from "./ScrollToTop";
import Referral from "./views/pages/privatePages/referral";
import {
  APP_CONST,
  AppDetailsCacheDuration,
  AppDetailsCacheStorageKey,
  UPDATE_PASSWORD_FLAG_KEY,
} from "./config/const";
import CommonRoutes from "./routing/CommonRoutes";
import Netent from "./views/pages/privatePages/Slots/Netent";
import RedTiger from "./views/pages/privatePages/Slots/RedTiger";
import DynamicManualWithdrawGtw from "./views/pages/privatePages/withdraw/dynamicManual/gateway";
import KycModule from "./views/pages/privatePages/kyc";
import KycDetail from "./views/pages/privatePages/kyc/kyc";
import DepositListPage from "./views/pages/privatePages/deposit/depositList";
import Bonus from "./views/pages/privatePages/bonus";
import BonusCard from "./views/pages/privatePages/bonus/bonusCard";
import Offers from "./views/pages/privatePages/offers";
import Jackpots from "./views/pages/privatePages/jackpots";
import VIP from "./views/pages/privatePages/vip";

const CasinoGamesListing = React.lazy(() =>
  import("./views/pages/privatePages/casino")
);
const Page404 = React.lazy(() => import("./views/pages/privatePages/page404"));
const AboutUs = React.lazy(() =>
  import("./views/pages/commonPages/FooterPages/AboutUs")
);
const ContactUs = React.lazy(() =>
  import("./views/pages/commonPages/FooterPages/ContactUs")
);
const FairPlay = React.lazy(() =>
  import("./views/pages/commonPages/FooterPages/FairPlay")
);
const GamesRule = React.lazy(() =>
  import("./views/pages/commonPages/FooterPages/GamesRule")
);
const PrivacyPolicy = React.lazy(() =>
  import("./views/pages/commonPages/FooterPages/PrivacyPolicy")
);
const ResponsibleGame = React.lazy(() =>
  import("./views/pages/commonPages/FooterPages/ResponsibleGame")
);
const Terms = React.lazy(() =>
  import("./views/pages/commonPages/FooterPages/Terms")
);
const WinningRules = React.lazy(() =>
  import("./views/pages/commonPages/FooterPages/WinningRules")
);
const Home = React.lazy(() => import("./views/pages/privatePages/home"));
const Games = React.lazy(() => import("./views/pages/privatePages/games"));
const DynamicCasinoPage = React.lazy(() =>
  import("./views/pages/privatePages/games/DynamicCasinoPage")
);
const Cashier = React.lazy(() => import("./views/pages/privatePages/cashier"));
const LandingPage = React.lazy(() =>
  import("./views/pages/publicPages/landingPage")
);
const Withdraw = React.lazy(() =>
  import("./views/pages/privatePages/withdraw")
);
const MobileNumber = React.lazy(() =>
  import("./views/pages/publicPages/register/mobileNumber")
);
const Profile = React.lazy(() => import("./views/pages/privatePages/profile"));
const Sports = React.lazy(() => import("./views/pages/privatePages/sports"));
const ExchangeLobbyPage = React.lazy(() =>
  import("./views/pages/privatePages/exchange/ExchangeLobbyPage")
);
const MatchDetailPage = React.lazy(() =>
  import("./views/pages/privatePages/sports/matchDetailPage")
);
const MyBets = React.lazy(() => import("./views/pages/privatePages/myBets"));
const WithdrawList = React.lazy(() =>
  import("./views/pages/privatePages/withdraw/WithdrawList")
);
const ForgotPassword = React.lazy(() =>
  import("./views/pages/publicPages/forgotPassword")
);
const ResetPassword = React.lazy(() =>
  import("./views/pages/publicPages/forgotPassword/resetPassword")
);
const AtlasLobby = React.lazy(() =>
  import("./views/pages/privatePages/sportsBook/atlasLobby")
);
const Maintenance = React.lazy(() =>
  import("./views/pages/publicPages/Maintenance")
);

const Kingmaker = React.lazy(() =>
  import("./views/pages/privatePages/Kingmaker")
);

const Popular = React.lazy(() =>
  import("./views/pages/privatePages/Popular/index")
);
// const DepositList = React.lazy(() =>
//   import("./views/pages/privatePages/deposit/depositList")
// );

const App = () => {
  const { isAuth } = useSelector((state) => state.auth);
  const { appDetails, organisationStatus } = useSelector((state) => state.app);
  const [showUpdateProfileModal, setShowUpdateProfileModal] = useState(false);
  const updatePasswordFlag =
    localStorage.getItem(UPDATE_PASSWORD_FLAG_KEY) === "true";

  const dispatch = useDispatch();

  useEffect(() => {
    // document.title = appDetails?.SEO_TITLE || "";
    document.canonical = appDetails?.LOGO_URL;
    // check organisation status
    if (
      organisationStatus !== null &&
      organisationStatus !== APP_CONST.ORGANISATION_STATUS.Live &&
      window.location.pathname.indexOf("maintenance") < 0
    ) {
      window.location.href = "/maintenance";
    }
  }, [appDetails]);

  const setVhUnit = () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  };

  useEffect(() => {
    // dispatch(getAppDetails());
    getAppDetailsAndValidateForCache();

    console.log("test log ==>154");
    setVhUnit();
    window.addEventListener("resize", setVhUnit);
    return () => {
      window.removeEventListener("resize", setVhUnit);
    };
  }, []);

  const getAppDetailsAndValidateForCache = () => {
    // const cachedValue =
    //   sessionStorage.getItem(AppDetailsCacheStorageKey) &&
    //   parseInt(sessionStorage.getItem(AppDetailsCacheStorageKey));

    // if (
    //   cachedValue &&
    //   Date.now() - cachedValue <= AppDetailsCacheDuration &&
    //   appDetails
    // ) {
    //   return;
    // }

    dispatch(
      getAppDetails(() => {
        sessionStorage.setItem(
          AppDetailsCacheStorageKey,
          JSON.stringify(Date.now())
        );
      })
    );
  };

  useEffect(() => {
    if (updatePasswordFlag) {
      setShowUpdateProfileModal(true);
    }
  }, [updatePasswordFlag]);

  return (
    <Router>
      <ScrollToTop />

      <ToastContainer
        closeButton={false}
        position="top-right"
        autoClose={1000}
      />
      <Suspense
        fallback={
          <div className="loaderImg">
            <img alt="Loader Image" src={Loader} />
          </div>
        }
      >
        {/* {isAuth && showUpdateProfileModal && (
          <UpdatePasswordModal
            show={showUpdateProfileModal}
            setShow={setShowUpdateProfileModal}
          />
        )} */}
        <Routes>
          <Route
            path="/"
            element={
              <PublicRoutes isAuth={isAuth}>
                <LandingPage />
                {/* <BeforeLoginFooter /> */}
              </PublicRoutes>
            }
          />
          <Route
            path="/maintenance"
            element={<Maintenance organisationStatus={organisationStatus} />}
          />
          <Route
            path="/home"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <Home />
                {/* <Footer /> */}
              </ProtectedRoutes>
            }
          />
          {/* KYC Route */}
          <Route
            path="/kyc"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <KycModule />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/kyc/:type"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <KycDetail />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/casino/list"
            element={
              <CommonRoutes disableFooter>
                <CasinoGamesListing />
              </CommonRoutes>
            }
          />
          <Route
            path="/games-all"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <Games />
                <Footer />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/Slots"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <Slots />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/netent"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <Netent />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/redtiger"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <RedTiger />
              </ProtectedRoutes>
            }
          />

          <Route
            path="/Spribe"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <Spribe />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/withdraw/gateways/:gateway"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <DynamicManualWithdrawGtw />
              </ProtectedRoutes>
            }
          />
          {/* <Route path="/how-to-join" element={<HowToJoin />} /> */}
          {/* <Route path="/how-to-deposit" element={<HowToDeposit />} />
          <Route path="/how-to-withdraw" element={<HowToWithdraw />} /> */}
          <Route
            path="/casino/:casinoslug"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <DynamicCasinoPage />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/sportsbook"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <PublicSportsBook />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/casino/:casinoslug/:gameslug"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <DynamicCasinoPage />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/bonus"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <Bonus />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/bonus/:id"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <BonusCard />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/venum"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <Popular />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/kingmaker"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <Kingmaker />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/cashier"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <Cashier />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/withdrawList"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <WithdrawList />
                <Footer />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/mybets"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <MyBets />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/deposit/:gateway"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <DepositGateway />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/deposit-list"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <DepositListPage />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/gatewaylist"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <GatewaysList />
                {/* <Footer /> */}
              </ProtectedRoutes>
            }
          />
          {/* <Route
            path="/deposit"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <Deposit />
                <Footer />
              </ProtectedRoutes>
            }
          /> */}
          {/* <Route
            path="/exchange"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <Sports isAuth={isAuth} />
              </ProtectedRoutes>
            }
          /> */}
          <Route
            path="/withdraw"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <Withdraw />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/mobile-number"
            element={
              <PublicRoutes isAuth={isAuth}>
                <MobileNumber />
              </PublicRoutes>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <Profile />
              </ProtectedRoutes>
            }
          />
          <Route path="test" element={<Sports />} />
          <Route
            // path="/sports/exchange"
            path="/sports/:gameId"
            element={
              <CommonRoutes isAuth={isAuth} disableFooter disableHeader>
                <ExchangeLobbyPage isAuth={isAuth} />
              </CommonRoutes>
            }
          />
          {/* <Route path="/betby" element={<Betby isAuth={isAuth} />} /> */}
          <Route path="/atlas-lobby" element={<AtlasLobby isAuth={isAuth} />} />
          <Route
            path="/detail-page/:slug/:matchId/:marketId/:sportId"
            element={
              <>
                <MatchDetailPage isAuth={isAuth} />
                {isAuth ? <Footer /> : <BeforeLoginFooter />}
              </>
            }
          />
          <Route
            path="/referral"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <Referral />
              </ProtectedRoutes>
            }
          />
          {/* <Route path="/contactus" element={<ContactUs />} /> */}
          <Route
            path="/sportsbooktest"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <TestSportsBook />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/forgot-password"
            element={
              <PublicRoutes isAuth={isAuth}>
                <ForgotPassword />
              </PublicRoutes>
            }
          />
          <Route
            path="/reset-password"
            element={
              <PublicRoutes isAuth={isAuth}>
                <ResetPassword />
              </PublicRoutes>
            }
          />

          {/* Common Routes */}
          <Route
            path="/aboutus"
            element={
              <CommonRoutes disableFooter>
                <AboutUs />
              </CommonRoutes>
            }
          />
          <Route
            path="/contactus"
            element={
              <CommonRoutes disableFooter>
                <ContactUs />
              </CommonRoutes>
            }
          />
          <Route
            path="/fairplay"
            element={
              <CommonRoutes disableFooter>
                <FairPlay />
              </CommonRoutes>
            }
          />
          <Route
            path="/gamesrule"
            element={
              <CommonRoutes disableFooter>
                <GamesRule />
              </CommonRoutes>
            }
          />
          <Route
            path="/privacypolicy"
            element={
              <CommonRoutes disableFooter>
                <PrivacyPolicy />
              </CommonRoutes>
            }
          />
          <Route
            path="/responsiblegames"
            element={
              <CommonRoutes disableFooter>
                <ResponsibleGame />
              </CommonRoutes>
            }
          />
          <Route
            path="/winning-rules"
            element={
              <CommonRoutes disableFooter>
                <WinningRules />
              </CommonRoutes>
            }
          />
          <Route
            path="/terms"
            element={
              <CommonRoutes disableFooter>
                <Terms />
              </CommonRoutes>
            }
          />

          <Route
            path="/404-page-not-found"
            element={<Page404 isAuth={isAuth} />}
          />
          <Route
            path="*"
            exact={true}
            element={<Navigate to="/404-page-not-found" />}
          />
          <Route
            path="/offers"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <Offers />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/jackpots"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <Jackpots />
              </ProtectedRoutes>
            }
          />
          <Route
            path="/vip"
            element={
              <ProtectedRoutes isAuth={isAuth}>
                <VIP />
              </ProtectedRoutes>
            }
          />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default App;
